import React from "react";
import { Input, Radio, Select } from "antd";
import { FilterField, CheckboxGrid } from "./FilterShared";
import { EXPERIENCE_OPTIONS } from "./filterOptions";

const BASE_SELECT = { style: { width: "100%" }, allowClear: true };
const TAG_SELECT = { ...BASE_SELECT, mode: "tags", filterOption: false, tokenSeparators: [","] };
const PMT_EXPERIENCE_OPTIONS = [
  "Less than 1 year",
  "1-2 years",
  "3-5 years",
  "6-10 years",
  "More than 10 years",
].map((option) => ({ title: option, value: option }));
const GIG_TYPE_OPTIONS = ["Contract", "Permanent", "PerDiem"];
const BUDGET_TYPE_OPTIONS = [
  { value: "Hour", label: "Hourly" },
  { value: "Week", label: "Weekly" },
  { value: "Year", label: "Yearly" },
];

const SkillsPanel = ({ values = {}, set, skillSearch = {}, useLegacyExperience = false }) => {
  const safeSet = (key) => set?.(key) || (() => {});

  return (
    <div className="qp-filter-panel-body">
      <FilterField label="Skills">
        <Select
          {...TAG_SELECT}
          showSearch
          placeholder="e.g. React, Python"
          onSearch={skillSearch.onSearch}
          loading={Boolean(skillSearch.loading)}
          options={Array.isArray(skillSearch.opts) ? skillSearch.opts : []}
          value={Array.isArray(values.skill) ? values.skill : []}
          onChange={safeSet("skill")}
          notFoundContent={
            skillSearch.loading ? "Searching…" : "Type to search or add"
          }
        />
      </FilterField>

      {useLegacyExperience ? (
        <>
          <FilterField label="Skill Listing Type">
            <Radio.Group
              className="qp-filter-radio-grid"
              value={values.skillListingType || undefined}
              onChange={(event) => safeSet("skillListingType")(event.target.value)}
            >
              {GIG_TYPE_OPTIONS.map((option) => (
                <Radio key={option} value={option}>
                  {option === "PerDiem" ? "Per diem" : option}
                </Radio>
              ))}
            </Radio.Group>
          </FilterField>

          <FilterField label="Experience">
            <CheckboxGrid
              options={PMT_EXPERIENCE_OPTIONS}
              value={Array.isArray(values.experienceLevel) ? values.experienceLevel : []}
              onChange={safeSet("experienceLevel")}
            />
          </FilterField>
        </>
      ) : (
        <>
          <FilterField label="Years of Experience">
            <CheckboxGrid
              options={EXPERIENCE_OPTIONS}
              value={Array.isArray(values.yearsOfExp) ? values.yearsOfExp : []}
              onChange={safeSet("yearsOfExp")}
            />
          </FilterField>

          <FilterField label="Years in Current Role">
            <CheckboxGrid
              options={EXPERIENCE_OPTIONS}
              value={Array.isArray(values.yearsOfExpCurrentRole) ? values.yearsOfExpCurrentRole : []}
              onChange={safeSet("yearsOfExpCurrentRole")}
            />
          </FilterField>
        </>
      )}
    </div>
  );
};

export default SkillsPanel;
